import { Link } from "react-router-dom";
import { blogs } from "../../data/blogs";

const RelatedBlogs = ({ currentBlog }) => {
  const relatedBlogs = blogs
    .filter(
      (blog) =>
        blog.id !== currentBlog.id &&
        blog.category === currentBlog.category
    )
    .slice(0, 3);

  if (!relatedBlogs.length) return null;

  return (
    <section className="py-24 bg-slate-50">
      <div className="container-custom">

        <div className="text-center mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Related Articles
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            You May Also Like
          </h2>

        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {relatedBlogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-white rounded-3xl overflow-hidden shadow-lg"
            >

              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-64 object-cover"
              />

              <div className="p-6">

                <span className="text-[#F59E0B] text-sm font-semibold">
                  {blog.category}
                </span>

                <h3 className="text-xl font-bold text-[#082B57] mt-3">
                  {blog.title}
                </h3>

                <p className="text-gray-600 mt-4">
                  {blog.excerpt}
                </p>

                <Link
                  to={`/blogs/${blog.slug}`}
                  className="inline-block mt-6 text-[#F59E0B] font-semibold"
                >
                  Read More →
                </Link>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default RelatedBlogs;